"use client"

import { NotebookPen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `NotebookPenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const NotebookPenIcon = component(Icon)({ as: NotebookPen })
